import React from "react";
import ReactDOM from "react-dom/client";
import "./app/sanitizeLinks";
// import './index.css'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Layout from "./app/Layout";
import HomePage from "./app/pages/HomePage";
import NotFound from "./app/pages/NotFoundPage";
import TokenLoginPage from "./app/pages/TokenLoginPage";
import "./styles/_base.scss";
import AboutPage from "./app/pages/AboutProgram";
import ContactPage from "./app/pages/Contact";
import Recommend from "./app/pages/Recommend";
import CouponsPage from "./app/pages/Coupons";
import Profile from "./app/pages/Profile";
import UserData from "./app/pages/Profile/UserData";
import Terms from "./app/pages/Profile/Terms";
import Points from "./app/pages/Profile/Points";
import Activities from "./app/pages/Activities";
import GameProvider from "./app/pages/Activities/GameProvider";
import IntroTemplate from "./app/pages/Activities/IntroTemplate";
import Regulations from "./app/pages/Regulations";
import FaqPage from "./app/pages/AboutProgram/Faq";
import Essentials from "./app/pages/AboutProgram/Essentials";
import RecommendGlo from "./app/pages/Recommend/RecommendGlo";
import RecommendVuse from "./app/pages/Recommend/RecommendVuse";
import ReceivedCouponsPage from "./app/pages/Coupons/Received";
import RedeemAwardPage from "./app/pages/Coupons/Redeem";
import RedeemUltraInsider from "./app/pages/Coupons/RedeemUltraInsider";
import RedeemPrizePage from "./app/pages/Coupons/RedeemPrize";
import ReceivedCouponPage from "./app/pages/Coupons/ReceivedCoupon";
import RegulationPage from "./app/pages/Regulations/RegulationPage";
import GoalsPage from "@pages/GoalsPage";
// import FashionWeek from "@pages/Activities/Activities/Mechanics/FashionWeek";
import VuseUltra3D from "@pages/Activities/Activities/Mechanics/VuseUltra3D";
import IntroContestTemplate from "@pages/Activities/IntroContestTemplate";
// import ContestGalleryFashionWeek from "@pages/Activities/Activities/Mechanics/FashionWeek/ContestGallery";
import GloStory from "./app/pages/GloStory";
import QrLanding from "./app/pages/QrLanding";
import EasterEggPage from "@pages/EasterEggPage";
import UltraInsider from "@pages/UltraInsider";
import Benefits from "@pages/UltraInsider/Benefits";
import UltraCare from "@pages/UltraInsider/UltraCare";
import InspirationClubBrithdayPage from "@pages/InspirationClubBrithday";
import MenuSkins from "@pages/Profile/MenuSkins";
import QrScannerRoute from "@pages/QrScannerLanding/QrScannerRoute";
import QrRegister from "@pages/QrRegister";
import SubscriptionPage from "@pages/SubscriptionPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
      cacheTime: Infinity,
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,

    children: [
      {
        index: true,
        element: <HomePage />,
      },
      // {
      //   path: "/inspirationClubBrithdayPage",
      //   element: <InspirationClubBrithdayPage />,
      // },
      {
        path: "/subscription",
        element: <SubscriptionPage />,
      },
      {
        path: "/coupons",
        element: <CouponsPage />,
      },
      {
        path: "/coupons/received",
        element: <ReceivedCouponsPage />,
      },
      {
        path: "/coupons/redeem",
        element: <RedeemAwardPage />,
      },
      {
        path: "/coupons/received/:uuid",
        element: <ReceivedCouponPage />,
      },
      {
        path: "/coupons/redeem/:ident",
        element: <RedeemAwardPage />,
      },
      {
        path: "/prize/redeem/:uuid",
        element: <RedeemPrizePage />,
      },
      {
        path: "/coupons/ultra-insider/redeem/:ident",
        element: <RedeemUltraInsider />,
      },
      import.meta.env.VITE_BRANCH === "dev" && {
        path: "/token",
        element: <TokenLoginPage />,
      },
      {
        path: "/activities",
        element: <Activities />,
      },
      {
        path: "/ultra-insider",
        element: <UltraInsider />,
        children: [
          {
            path: "benefits",
            element: <Benefits />,
          },
          {
            path: "ultra-care",
            element: <UltraCare />,
          },
        ],
      },
      // {
      //   path: "activities/fashion-week",
      //   element: <FashionWeek />,
      // },
      {
        path: "activities/vuse-ultra-3d",
        element: <VuseUltra3D />,
      },
      {
        path: "activities/:ident",
        element: <IntroTemplate />,
      },
      {
        path: "contest/:ident/:page?",
        element: <IntroContestTemplate />,
      },
      // {
      //   path: "/fashion_week_vuse/gallery",
      //   element: <ContestGalleryFashionWeek />,
      // },
      {
        path: "activities/:ident/gra",
        element: <GameProvider />,
      },
      {
        path: "/invite",
        element: <Recommend />,
        children: [
          // {
          //   path: "glo",
          //   element: <RecommendGlo />,
          // },
          {
            path: "vuse",
            element: <RecommendVuse />,
          },
        ],
      },
      {
        path: "/about",
        element: <AboutPage />,
        children: [
          {
            path: "essentials",
            element: <Essentials />,
          },
          {
            path: "faq",
            element: <FaqPage />,
          },
        ],
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "/terms",
        element: <Regulations />,
      },
      {
        path: "/terms/:uuid",
        element: <RegulationPage />,
      },
      {
        path: "/profil",
        element: <Profile />,
        children: [
          {
            path: "user-data",
            element: <UserData />,
          },
          {
            path: "consents",
            element: <Terms />,
          },
          {
            path: "points",
            element: <Points />,
          },
          {
            path: "menu-skins",
            element: <MenuSkins />,
          },
        ],
      },
      {
        path: "/glo-story",
        element: <GloStory />,
      },
      {
        path: "/qr-scanner-landing",
        element: <QrScannerRoute />,
      },
      {
        path: "/qrv/:code",
        element: <QrLanding />,
      },
      {
        path: "/qr-register/:code?",
        element: <QrRegister />,
      },
      {
        path: "/404",
        element: <NotFound />,
      },
      {
        path: "/*",
        element: <NotFound />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {import.meta.env.VITE_SHOW_QUERY_DEVTOOLS === "true" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
);
